export const VAULT_CLIENT_ID = 'partner';
export const CHALLENGE_MAX_ATTEMPTS = 5;
export const EMAIL_CODE_RESEND_COOLDOWN_MS = 30000;

const CHALLENGE_TOKEN_KEY = 'vault_challenge_token';
const REFRESH_LOCK_NAME = 'vault_token_refresh';

export function storeChallengeToken(token) {
    try {
        window.sessionStorage.setItem(CHALLENGE_TOKEN_KEY, token);
    } catch (e) {
        return;
    }
}

export function getChallengeToken() {
    try {
        return window.sessionStorage.getItem(CHALLENGE_TOKEN_KEY);
    } catch (e) {
        return null;
    }
}

export function clearChallengeToken() {
    try {
        window.sessionStorage.removeItem(CHALLENGE_TOKEN_KEY);
    } catch (e) {
        return;
    }
}

export function withRefreshLock(task) {
    if (!('locks' in navigator)) {
        return task();
    }

    return navigator.locks.request(REFRESH_LOCK_NAME, task);
}

export function normalizeRecoveryCode(input) {
    const compact = (input ?? '').replace(/[\s-]/g, '').toUpperCase();

    return compact.length === 10 ? `${compact.slice(0, 5)}-${compact.slice(5)}` : compact;
}

export function isRecoveryCode(input) {
    return /^[0-9A-F]{5}-[0-9A-F]{5}$/.test(normalizeRecoveryCode(input));
}

export function isVerificationCode(input) {
    return /^\d{6}$/.test(input ?? '');
}
